<template>
  <div @click="handleClick">
    <span class="index" :style="{
      backgroundColor: color,
      color: textColor
    }">
      {{ $gettext(text) }}
    </span>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'ButtonFilter',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      default: '#fff'
    }
  }
})

class ButtonFilter extends Vue {
  handleClick () {
    this.$emit('clickAction', this.text)
  }
}

export default ButtonFilter
</script>
<style scoped>
  .index {
    border-radius: 25px;
    padding: 4px 14px;
    max-height: 25px;
    white-space: nowrap;
    cursor: pointer;
  }
</style>
